<template>
    <y-panel-grid :service="$services.Accountant.postingsGrid" />
</template>

<script>

    import GridPageMixin from '@/mixins/GridPage';

    export default {

        name: 'PostingsGrid',

        mixins: [GridPageMixin],

        /**
         * @inheritDoc
         */
        breadcrumbs() {
            return [
                this.$bc('dashboard', this.$t('breadcrumbs.dashboard')),
            ];
        },

    };

</script>
